import {groupWorkspaceReservationAdapter, workspaceReservationsAdapter} from './adapters';
import {GroupWorkspaceReservationsState, WorkspaceReservationsSliceState, WorkspaceReservationsState} from './types';

export const initialState: WorkspaceReservationsSliceState = {
  workspaceReservations: <WorkspaceReservationsState>workspaceReservationsAdapter.getInitialState(),
  workspaceReservationCountPerNodeOnDate: {},
  isLoading: false,
  isCreating: false,
  updates: {},
  deletions: {},
  lastSelectedLocation: {
    buildingId: '',
    floorId: '',
    areaId: '',
    deskId: '',
  },
  isLastSelectedLocationLoaded: false,
  groupWorkspaceReservations: <GroupWorkspaceReservationsState>groupWorkspaceReservationAdapter.getInitialState(),
  isLoadingGroupWorkspaceReservations: false,
  isUpdatingGroupWorkspaceReservationStatus: false,
  searchedInvitees: [],
  inviteesSearchStatus: 'NotLoaded',
  isDeletingTodayRegistration: false,
  isDeletingRegistration: false,
};
